export function getTotals(incidentData) {
    const counterObj = {};
    const incidentKeys = Object?.keys?.(incidentData);

    const cols = [
        { label: "Feridos", id: "feridos" },
        { label: "Fatalidades", id: "fatalidades" },
        { label: "Total", id: "total" }
    ];

    const rows = [
        { label: "3ªs Partes", id: "terceiros" },
        { label: "Contratados", id: "contratados" },
        { label: "GIMTL", id: "samcol" },
        { label: "Total", id: "totalVertical" }
    ];

    let totalRowsSum = 0;
    let totalColsSum = 0;

    for (const row of rows) {
        const keys = incidentKeys.filter(key => key.includes(row.id));
        if (keys.length > 0) {
            let rowTotal = 0;
            for (const key of keys) {
                const value = incidentData[key];
                if (typeof value === 'number') {
                    rowTotal += value;
                }
            }

            counterObj[`${row.id}_total`] = rowTotal;
            totalRowsSum += rowTotal;
        }
    }

    for (const col of cols) {
        const keys = incidentKeys.filter(key => key.includes(col.id));
        if (keys.length > 0) {
            let colTotal = 0;
            for (const key of keys) {
                const value = incidentData[key];
                if (typeof value === 'number') {
                    colTotal += value;
                }
            }

            counterObj[`totalVertical_${col.id}`] = colTotal;
            totalColsSum += colTotal;
        }
    }

    counterObj['totalVertical_total'] = totalRowsSum + totalColsSum;

    return counterObj;
}
